import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc0176',
    ecrans: ['00-2'],
    params:['?stamnetab','?ovdcleintref']
});
